import styled from 'styled-components';
import { scale } from './Animations';

const Option = styled.li`
  animation: ${scale} 0.3s ease forwards;
  display: inline-block;
  padding: 0 !important;
  line-height: initial !important;
  margin: ${props => (props.variant === 'rate' ? '0 auto' : '2px')};
  transform: scale(0);
  cursor: ${props => (!props.clickable ? 'default' : 'pointer')};
  &:before{
    display: none !important;
  }
`;

export default Option;